import React, { useContext } from "react";
import { store } from "../store.js";

const useValidationInput = () => {
  const globalState = useContext(store);

  const isTypeValid = (type,  newInput) => {
    var result = {}
    
    switch (type) {
      case globalState.state.formData.actions.validation.type.Require:{
        result["data"] = newInput.value;
             
        if (newInput.value == undefined || newInput.value == "") {
          result["isValid"] = false
        }
        else {
          result["isValid"] = true
        }
        break;
      }
      case globalState.state.formData.actions.validation.type.Number:{
        result["data"] = newInput.value;
        var isValid = true
        if(newInput.masks && newInput.masks != ""){
          const maskValues = newInput.masks.split("")
          var inputValue = newInput.value
          maskValues.map(mask => inputValue = inputValue.replaceAll(mask, ""))
          isValid = !inputValue.includes(" ") && !isNaN(inputValue) 
          
        }
        else if(newInput.wholeNumberLength && newInput.wholeNumberLength){
          var wholePart = newInput.value.replaceAll(newInput.groupSeparator,"")
          var decimalPart = ""
          if (newInput.decimalSeparator != "") {
            const number = wholePart.split(newInput.decimalSeparator)
            wholePart = number[0]
            decimalPart = number.length > 1 ? number[1] : ""
          }
          if (wholePart.length > newInput.wholeNumberLength || decimalPart.length > newInput.decimalSize )
            isValid = false
        }
        else{
          const canAddDecimalChar = newInput.decimalSeparator == newInput.value && !newInput.actualValue.includes(newInput.value) 
          isValid = !newInput.value.includes(" ") && (!isNaN(newInput.value) || canAddDecimalChar )
        }
        
        if (isValid)
          result["isValid"] = true
        else 
          result["isValid"] = false
        break;
      } 
      case globalState.state.formData.actions.validation.type.Size:{
        result["data"] = newInput.value;
        if (newInput.value.length > newInput.maxSize) {
          result["isValid"] = false
        }
        else {
          result["isValid"] = true
        }
        break;
      } 
      case globalState.state.formData.actions.validation.type.Unique:{
        result["data"] = newInput.value;
        if (newInput.values.includes(newInput.value.toLowerCase())) {
          
          result["isValid"] = false
        }
        else {
          result["isValid"] = true
        }
        break;
      } 
      case globalState.state.formData.actions.validation.type.NoSpace:{
        result["data"] = newInput.value;
        if (newInput.value.includes(" ")) {
          result["isValid"] = false
        }
        else {
          result["isValid"] = true
        }
        break;
      } 
      case globalState.state.formData.actions.validation.type.NoSpecialChar:{
        result["data"] = newInput.value;
        if (newInput.value.replace(/[^\w\s]/gi, "$") == "$") {
          result["isValid"] = false
        }
        else {
          result["isValid"] = true
        }
        break;
      }
      case globalState.state.formData.actions.validation.type.Email:{
        result["data"] = newInput.value;
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        //if (newInput.value.replace(/[^\w\s]/gi, "$") == "$") {
        if (!pattern.test(newInput.value))
          result["isValid"] = false
        else 
          result["isValid"] = true
        
        break;
      } 
      case globalState.state.formData.actions.validation.type.Json:{
        
        if (isValidJson(newInput))
          result["isValid"] = true
        else 
          result["isValid"] = false
        break;
      } 
      case globalState.state.formData.actions.validation.type.Xml:{
        
        if (isValidXml(newInput))
          result["isValid"] = true
        else 
          result["isValid"] = false
        break;
      } 
    }
    return result;
  }

  const isValidJson = (newInput) => {
    try {
      JSON.parse(newInput.value.data);
    } catch (e){
      return false
    }
    return true
  }

  const isValidXml = (newInput) => {
    var domParser = new DOMParser()
    var dom = domParser.parseFromString(newInput.value.data, "text/xml")
    return dom.getElementsByTagName("parsererror").length == 0
  }


  const isInputValid = (value, typeEvents) => {
    var isValid = true;
    var type = undefined
    //const typeEvents = globalState.state.formData.menu[menuType].validations[event]
    
    if (typeEvents) {
      
      const typeValidations = typeEvents.map(item => item.type);
      const n = typeValidations.length; 
      var i = 0;
     
      while (i < n && isValid) {
        type = typeValidations[i]
        isValid = isTypeValid(type, value).isValid
        
        i += 1
      }
    }
    
    return {isValid:isValid, type:type}
  }

  return isInputValid;
};

export default useValidationInput;
